/**
 * @description Curried function that returns an object of functions that compare
 * the first argument with argument provided to them.
 *
 * @param {Date} date The first given date.
 *
 * @returns {{[string]: (Date) => boolean}} Object containing functions to compare the first date argument with.
 */
export var is = function (date) {
    var firstGivenDate = date.getTime();
    return {
        after: function (secondGivenDate) { return firstGivenDate > secondGivenDate.getTime(); },
        before: function (secondGivenDate) { return firstGivenDate < secondGivenDate.getTime(); }
    };
};
//# sourceMappingURL=is.js.map